import axios from 'axios';

export const http = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL, 
  timeout: 10000,
});

